import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import { Tag } from "./tag";

import "./selected.tag.scss";

const defaultText = "selected";

export const SelectedTag = ({ text }) => {
  return (
    <Tag
      className="tx-selected-tag"
      value={
        <>
          <FontAwesomeIcon icon={["fasr", "circle-check"]} />
          <span>{text ?? defaultText}</span>
        </>
      }
    />
  );
};

SelectedTag.propTypes = {
  text: PropTypes.string,
};
